import {
    LB_PARK, LB_RESTAURANT, LB_SPA, LB_SPECIALS,
    LB_TRANSPORTATION, LB_WL_ACTIVITY
} from "../components/i18n/i18n";

export const wishlistTypes = {
    afi: Symbol('AFI'),
    restaurant: Symbol('RESTAURANT'),
    spa: Symbol('SPA'),
    activity: Symbol('ACTIVITY'),
    transportation: Symbol('TRANSPORTATION'),
    special: Symbol('SPECIAL'),
    default: Symbol('DEFAULT'),
}

export const wishlistStatus = {
    processing: Symbol('PROCESSING'),
    confirmed: Symbol('CONFIRMED'),
    rejected: Symbol('REJECTED'),
}

export const specialsOptions = {
    birthday: Symbol('cel_birthday'),
    anniversary: Symbol('cel_anniversary'),
    honeyMoon: Symbol('cel_honeymoon'),
    otherCelebration: Symbol('cel_others'),
    allergies: Symbol('ces_alres'),
    handicap: Symbol('ces_handicap'),
    pet: Symbol('ces_pet'),
    otherSpecialCases: Symbol('ces_others'),
}

export const restaurantPaxRestriction = {
    vegetarian: Symbol('rest_vegetarian'),
    vegan: Symbol('rest_vegan'),
    gluten_free: Symbol('rest_gluten_free'),
    rest_alim: Symbol('rest_rest_alim'),
    allergic: Symbol('rest_allergic'),
}

export const wishlistTotalsOptions = [
    {
        code: 'TOTALS',
        title:'TOTAL',
        style:'wl-totals-total'
    },
    {
        code: wishlistStatus.confirmed.description,
        title:'Confirmados',
        style:'wl-totals-confirmed'
    },
    {
        code: wishlistStatus.processing.description,
        title:'Procesando',
        style:'wl-totals-processed '
    },
    {
        code: wishlistStatus.rejected.description,
        title:'Rechazados',
        style:'wl-totals-rejected'
    }
]

export const wishlistOptions = [
    {
        type: wishlistTypes.afi,
        code: wishlistTypes.afi.description,
        title: LB_PARK,
        icon: 'parques_ic@.png',
        enabled:true,
        default:false
    },{
        type: wishlistTypes.restaurant,
        code: wishlistTypes.restaurant.description,
        title: LB_RESTAURANT,
        icon: 'restaurantes_ic@.png',
        enabled:false,
        default:false
    },{
        type: wishlistTypes.spa,
        code: wishlistTypes.spa.description,
        title: LB_SPA,
        icon: 'spa_ic@.png',
        enabled:false,
        default:false
    },{
        type: wishlistTypes.activity,
        code: wishlistTypes.activity.description,
        title: LB_WL_ACTIVITY,
        icon:'talleres_ic@.png',
        enabled:false,
        default:false
    },{
        type: wishlistTypes.transportation,
        code: wishlistTypes.transportation.description,
        title: LB_TRANSPORTATION,
        icon: 'transportacion_ic@.png',
        enabled:true,
        default:false
    },{
        type: wishlistTypes.special,
        code: wishlistTypes.special.description,
        title: LB_SPECIALS,
        icon: 'especiales_ic@.png',
        enabled:false,
        default: false
    },{
        type: wishlistTypes.default,
        code: wishlistTypes.default.description,
        title:'Selecciona una opción',
        enabled:true,
        default:true
    }
]

export const wishlistStatusOptions = [
    {
        type: wishlistStatus.processing,
        title:'Procesando',
        color:'primary',
        bgColor:'bg-new'
    },{
        type: wishlistStatus.confirmed,
        title:'Confirmados',
        color:'success',
        bgColor:'bg-confirmed'
    },{
        type: wishlistStatus.rejected,
        title:'Rechazados',
        color:'danger',
        bgColor:'bg-rejected'
    }
]

export const getWishlistOption = (type= wishlistTypes.default) => wishlistOptions.find( option => option?.type == type)
export const getWishlistOptions = () => wishlistOptions.filter(option => option?.default == false )
export const geWishlistStatus = status => wishlistStatusOptions.find( option => option?.type?.description === status)
export const geWishlistTotalOption = code => wishlistTotalsOptions.find( option => option?.code === code)